import type { BandCue, BandCueChannel } from '../score/types';

/** The accompanying staff text stays visible; this marker carries its
 * playback semantics without adding duplicate words on any part. */
export const MUSICXML_BAND_CUE_OTHER_PLAY_TYPE = 'scoreguard-band-cue';

export function parseBandCueMarker(direction: Element): BandCue | undefined {
  const value = Array.from(direction.getElementsByTagName('other-play')).find(
    (node) => node.getAttribute('type') === MUSICXML_BAND_CUE_OTHER_PLAY_TYPE,
  )?.textContent;
  if (!value) return undefined;
  try {
    const cue: unknown = JSON.parse(value);
    if (!cue || typeof cue !== 'object' || !('mode' in cue)) return undefined;
    if (cue.mode !== 'play' && cue.mode !== 'rest' && cue.mode !== 'hit') return undefined;
    let channels: BandCueChannel[] | undefined;
    if ('channels' in cue) {
      if (
        !Array.isArray(cue.channels) ||
        !cue.channels.length ||
        !cue.channels.every(
          (channel): channel is BandCueChannel =>
            channel === 'comp' || channel === 'bass' || channel === 'drums',
        )
      )
        return undefined;
      channels = [...cue.channels];
    }
    let duration: BandCue['duration'];
    if ('duration' in cue) {
      const d = cue.duration;
      if (
        !d ||
        typeof d !== 'object' ||
        !('num' in d) ||
        !('den' in d) ||
        typeof d.num !== 'number' ||
        typeof d.den !== 'number' ||
        !Number.isSafeInteger(d.num) ||
        !Number.isSafeInteger(d.den) ||
        d.num <= 0 ||
        d.den <= 0
      )
        return undefined;
      duration = { num: d.num, den: d.den };
    }
    return { mode: cue.mode, ...(channels ? { channels } : {}), ...(duration ? { duration } : {}) };
  } catch {
    return undefined;
  }
}
